// Copyright ©️ 2026 eVolve MEP, LLC

import type * as THREE from 'three';

import { AngleLabel } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/Labels/AngleLabel';
import { MeasurementLabel } from 'modules/Shop/EvolveFabrication/BendCreator/BendPreview/Labels/MeasurementLabel';

import type { LabelOpts } from './buildLabelOpts';

/**
 * Factory function to create a label based on the provided label options.
 * @param labelOpt a label options object.
 * @param group the THREE.Group to which the label will be added.
 * @param showValue optional boolean to indicate whether to show the value of the label (e.g., length or angle). @default false
 */
export const makeLabelFromLabelOpt = (labelOpt: LabelOpts, group: THREE.Group, showValue: boolean = false) => {
  if (labelOpt.kind === 'angle') return new AngleLabel({ ...labelOpt, group, showValue });
  return new MeasurementLabel({ ...labelOpt, group, showValue });
};
